import type { AnalyticsSettingsAddon } from 'owa-analytics-types';
import type { MailboxInfo } from 'owa-client-types';
import { getAnalyticsAddon } from 'owa-analytics-addons';

/**
 * Gets the resolved MailboxInfo for telemetry logging using the AnalyticsSettings addon.
 * For UIB (UnifiedInbox), PST, and MSG mailbox types, returns the Global Settings Account's MailboxInfo.
 * For all other mailbox types, returns the original mailboxInfo unchanged.
 *
 * @param mailboxInfo - The mailbox info to resolve
 * @returns The resolved mailbox info for telemetry, or the original if addon is not available
 */
export function getResolvedMailboxInfoForTelemetry(
    mailboxInfo: MailboxInfo | undefined
): MailboxInfo | undefined {
    if (!mailboxInfo) {
        return undefined;
    }

    try {
        const addon = getAnalyticsAddon<AnalyticsSettingsAddon>('AnalyticsSettings')?.executeNow();
        return addon?.resolveMailboxInfoForTelemetry(mailboxInfo) ?? mailboxInfo;
    } catch {
        // If addon is not registered yet, return the original mailboxInfo
        return mailboxInfo;
    }
}
